import React, {useContext, useEffect, useState} from 'react';
import {Col, Row, Container} from 'reactstrap';
import {getSystemStatus} from 'utils/api';
import {isEmpty, startCase} from 'lodash';
import Loader from 'components/Loader';
import StatusItem from './StatusItem';
import moment from 'moment-timezone';
import './style.scss';
import {ErrorContext} from 'contexts/ErrorContext';

const Status = () => {
    const {handleError} = useContext(ErrorContext);
    const [fetchingData, setFetchingData] = useState(true);
    const [list, setList] = useState([]);
    const [lastChecked, setLastChecked] = useState(null);

    const fetchJwtStatus = async() => {
        try {
            const data = await getSystemStatus();
            console.log(data);
            setList(data.content);
            // setLastChecked(data.checked_at);
            setFetchingData(false);
        } catch(err) {
            setFetchingData(false);
            handleError(err);
        }
    };

    useEffect(() => {
        fetchJwtStatus();
    }, []);

    const handleMomentDisplay = () => {
        let a = moment();//now
        let b = moment(lastChecked);
        let mins = a.diff(b, 'minutes');
        let hours;
        if(mins < 1) {
            return ' less than a minute ago';
        }
        if(mins < 60) {
            return a.diff(b, 'minutes') + (a.diff(b, 'minutes') === 1 ? ' minute ago' : ' minutes ago');
        } else {
            hours = a.diff(b, 'hours');
            if(hours > 24) {
                return a.diff(b, 'days') + (a.diff(b, 'days') === 1 ? ' day ago' : ' days ago');
            } else {
                return hours + (hours === 1 ? ' hour ago' : ' hours ago');
            }
        }
    };

    return (
        <Container>
            <div className="animated fadeIn view status">
                <Row className="mb-3">
                    <Col xs="12">
                        <div>
                            <h2 className="mb-3 text-center">System Status</h2>
                            {lastChecked &&
                            <div className="status__last-updated" style={{color: 'gray', fontStyle: 'italic'}}>
                                Last checked {handleMomentDisplay()}
                            </div>
                            }
                            <>
                                {fetchingData ?
                                    <Loader small text="Fetching system status"/>
                                    :
                                    <>
                                        {list && list.length > 0 ?
                                            <>
                                                {list.map((listItem) => (
                                                    <div className="mt-2" key={listItem.id}>
                                                        <StatusItem
                                                            lastChecked={lastChecked}
                                                            // data={jwt[category].data}
                                                            item={listItem}
                                                            title={listItem.title}
                                                            mainStatus={listItem.status}
                                                        />
                                                    </div>
                                                ))}
                                            </>
                                            :
                                            <div className="status-error error-status">
                                                <i className="fa fa-exclamation-circle"/> Unable to fetch status updates
                                                at this time. Please try again later.
                                            </div>
                                        }
                                    </>
                                }
                            </>
                        </div>
                    </Col>
                </Row>
            </div>
        </Container>
    );
};

export default Status;
